<template>
  <div class="all" @keydown.enter="userlogin()">
    <div style="width: 65%; height: 100%">
      <div class="title_img">{{ name }}</div>
    </div>
    <div style="width: 35%; height: 100%; float: left">
      <div style="width: 100%; height: 15%"></div>
      <div style="width: 100%; height: 80%">
        <div style="
                      color: #00ffff;
                      font-size: 24px;
                      text-align: center;
                      width: 15%;
                      height: 5%;
                    ">登录</div>
        <div style="width: 15%; height: 0.6%; background: #ffffff"></div>
        <div style="width: 15%; height: 15%; background: rgba(255, 255, 255, 0)"></div>
        <div style="
                      width: 70%;
                      height: 5%;
                      color: #00ffff;
                      margin-left: 1%;
                      font-size: 14px;
                    ">用户名</div>
        <div style="width: 60%; height: 5%; color: #00ffff; margin-left: 1%">
          <input placeholder="请输入您的用户名" v-model="auto" style="
                        width: 70%;
                        height: 100%;
                        outline: none;
                        background-color: rgba(12, 15, 19, 0);
                        border: 0;
                        color: #ffffff;
                      " />
        </div>
        <div style="
                      width: 50%;
                      height: 0.1%;
                      background: rgba(255, 255, 255, 0.48);
                      color: #00ffff;
                    "></div>
        <div style="width: 45%; height: 6%"></div>
        <div style="
                      width: 70%;
                      height: 5%;
                      color: #00ffff;
                      margin-left: 1%;
                      font-size: 14px;
                    ">密码</div>
        <div style="width: 60%; height: 5%; color: #00ffff; margin-left: 1%">
          <input v-model="pass" type="password" placeholder="请输入您的密码" style="
                        width: 70%;
                        height: 100%;
                        outline: none;
                        background-color: rgba(12, 15, 19, 0);
                        border: 0;
                        color: #ffffff;
                      " />
        </div>
        <div style="
                      width: 50%;
                      height: 0.1%;
                      background: rgba(255, 255, 255, 0.48);
                      color: #00ffff;
                    "></div>
        <div style="width: 45%; height: 6%"></div>
        <div style="
                      width: 70%;
                      height: 5%;
                      color: #00ffff;
                      margin-left: 1%;
                      font-size: 14px;
                    ">验证码</div>
        <div style="
                      width: 60%;
                      height: 5%;
                      color: #00ffff;
                      margin-left: 1%;
                      display: flex;
                    ">
          <input id="code" v-model="code" placeholder="请输入验证码" style="
                        width: 50%;
                        height: 100%;
                        outline: none;
                        background-color: rgba(12, 15, 19, 0);
                        border: 0;
                        color: #ffffff;
                      " />
          <!-- <img
            src="https://api.suntaeiv.com/car_data/test/get_yzm"
            onclick="this.src=this.src+'?p='+Math.random()"
            style="float:left,width: 80%;height:80%;"
          />-->
          <img :src="img" style="float:left;width: 25%;height:90%;" @click="change()" />
        </div>
        <div style="   width: 50%;
                      height: 0.1%;
                      background: rgba(255, 255, 255, 0.48);
                      color: #00ffff;
                    "></div>
        <div style="width: 45%; height: 3%"></div>
        <div style="width: 45%; height: 2.5%" @click="userlogin()">
          <button style="
                        width: 100%;
                        height: 200%;
                        background-color: #00adff;
                        border: 0;
                        color: #ffffff;
                        font-size: 20px;
                      ">登录</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { get_verification_info, pclogin, get_info } from "../../api/login/api";
import { useRouter } from "vue-router";
import { Base64 } from 'js-base64'
import qs from 'qs';
import axios from "axios";
export default {
  name: "Login",
  setup() {
    const router = useRouter();
    const data = reactive({
      auto: "",
      pass: "",
      token: "",
      sk: "",
      img: "",
      code: "",
    });
    const datas = reactive({
      name: "",

    });
    let change = () => {
      get_verification_info().then((res) => {
        if (res.code === 0) {
          data.sk = res.data.sk;
          data.img = res.data.identify;
          window.localStorage.setItem("qlzx_monitoring_api_token", res.data.token);
          window.localStorage.setItem("qlzx_monitoring_api_sk", res.data.sk);
        }
      });
    };
    let info = () => {
      let k_host = window.location.host;
      k_host = Base64.encode(k_host);
      let data = { "domain": k_host };
      data = qs.stringify(data)
      axios.post("http://47.105.39.99:4578/manage_center/api/company_extend/get_company_extend_info_by_domain", data).then((res) => {
        let value = JSON.parse(res.data.data.value)
        window.document.title = value.cloudControlName
        datas.name = value.cloudControlName
        localStorage.setItem("info", res.data.data.value);
        changeFavicon(value.platformICO)
      })

    }
    info()
    const changeFavicon = (img) => {
      let favicon = document.querySelector('link[rel="icon"]')
      if (favicon !== null) {
        favicon.href = img
      } else {
        favicon = document.createElement('link')
        favicon.rel = 'icon'
        favicon.href = './public/favicon.ico'
        document.head.appendChild(favicon)
      }
    }
    let userlogin = () => {
      if (data.auto === "" || data.pass === "" || data.code === "") {
        ElMessageBox.alert("账户密码不能为空", "系统提示", {
          confirmButtonText: "OK",
        });
      } else {
        let time = Date.parse(new Date()).toString(); //获取到毫秒的时间戳，精确到毫秒
        time = time.substr(0, 10);
        pclogin(data.auto, data.pass, data.code).then(
          (res) => {
            if (res.code === 0) {
              let sent_data = { "account": Base64.encode(data.auto) };

              axios.post("http://47.105.39.99:8080/operation_dispatch_center/open/login", qs.stringify(sent_data)).then((res) => {
    
                localStorage.setItem("account",data.auto);
                localStorage.setItem("op_sk", res.data.data.sk);
                localStorage.setItem("op_token", res.data.data.token);
              })

              localStorage.setItem("selectTab_item", "Monitor");
              localStorage.setItem("notice_falg", 'true');
              router.push({ path: "/Home" });

            } else {
              if (res.message === "请输入正确的验证码" || res.message === "验证码错误") {
                data.code = "";
              } else if (res.message === "密码错误") {
                data.pass = "";
                data.code = "";
              } else {
                data.auto = "";
                data.pass = "";
                data.code = "";
              }
              change();
            }
          }
        );
      }
    };
    change();
    return { ...toRefs(data), ...toRefs(datas), userlogin, change };
  },

};
</script>
<style lang="scss" scoped>
// .all {
//   width: 100%;
//   height: 100%;
//   background-image: url("../../assets/img/back_login.png");
//   background-size: 100% 100%;
//   display: flex;
// }

.all {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/img/sun_back2.png");
  background-size: 100% 100%;
  display: flex;
}

.title_img {
  width: 50%;
  height: 10%;
  margin-top: 8%;
  margin-left: 20%;
  font-size: 4rem;
  color: rgb(255, 255, 255);
  font-family: \534e\6587\884c\6977;
  // background-image: url("../../assets/img/title_img.png");
  // background-size: 100% 100%;
  display: flex;
}
</style>